import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { listPartners } from '../../../../modules/partnerModule/partners';


import { useFormik } from 'formik';
import * as yup from 'yup';
import { listChances } from '../../../../modules/chanceModule/chances';
import CstStatusChip from '../../../../components/common/datagrid/CstStatusChip';
import { ProjectListBox } from '../../../../components/common/form/modal/ProjectListBox';
import ProjectList from '../../../../components/common/form/modal/ProjectList';

const ProjectListContainer = ({ handleClose, selectedProject }) => {
    const dispatch = useDispatch();


    const handleRowClick = (data) => {
        selectedProject(data.row);
        formik.resetForm();
        dispatch(listPartners());
        handleClose();

    }


    //searchForm
    const initialValues = {
        searchKeyword: 'cstNm',
        searchWords: '',
    };


    const validationSchema = yup.object({
        searchKeyword: yup.string('').nullable(),
        searchWords: yup.string('').trim().nullable(),

    });

    const { chances, error, loading } = useSelector(
        ({ chanceModule, loading }) => ({
            chances: chanceModule.chances.chances,
            error: chanceModule.chances.error,
            loading: loading['chance/LIST_CHANCES'],
        }),
    );

    // 컴포넌트 마운트 후 list 데이터 요청
    useEffect(() => {
        dispatch(listChances());
    }, []);


    const apiRef = useGridApiRef();


    const columns = useMemo(
        () => [
            {
                field: 'id',
                headerName: 'ID',
                hide: true,
                type: 'string',
                editable: false,
            },
            {
                field: 'prjSeq',
                headerName: '번호',
                align: 'center',
                headerAlign: 'center',
                minWidth: 80,
                flex: 0.3,
                editable: false,
            },
            {
                field: 'cstStatus',
                headerName: '상태',
                minWidth: 150,
                flex: 0.8,
                type: 'string',
                align: 'center',
                headerAlign: 'center',
                editable: false,
                renderCell: CstStatusChip,
            },
            {
                field: 'partnerInc',
                headerName: '고객명',
                minWidth: 200,
                flex: 1,
                type: 'string',
                editable: false,
            },
            {
                field: 'cstNm',
                headerName: '사업명',
                minWidth: 200,
                flex: 1,
                description: '',
                editable: false,
            },

            {
                field: 'prjUuid',
                headerName: '프로젝트 번호',
                minWidth: 200,
                flex: 1,
                type: 'string',
                editable: false,
                align: 'center',
                headerAlign: 'center',
                renderCell: (params) => (
                    params.row.prjNo
                ),

            },
            {
                field: 'crtDptNm',
                headerName: '부서',
                minWidth: 200,
                flex: 1,
                type: 'string',
                editable: false,
            },
            {
                field: 'crtNm',
                headerName: '생성자',
                minWidth: 80,
                flex: 1,
                type: 'string',
                editable: false,
                renderCell: (params) => (
                    <div>
                        {params.row.crtNm} {params.row.crtGradeNm}
                    </div>
                ),
            },

            {
                field: 'crtDt',
                headerName: '생성일',
                minWidth: 200,
                flex: 1,
                type: 'dateTime',
                editable: false,
            },

        ],
        [],
    );



    const formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { setSubmitting }) => {
            setSubmitting(true);
            let searchData = {
                [values.searchKeyword]: values.searchWords,
            };



            setTimeout(() => {
                // alert(JSON.stringify(values, null, 2));
                dispatch(listPartners(searchData));
                // formik.resetForm();
                setSubmitting(false);
            }, 1000);
        },
    });

    return (
        <div>
            <ProjectListBox formik={formik} />
            <ProjectList
                apiRef={apiRef}
                columns={columns}
                rows={chances}
                error={error}
                loading={loading}
                handleRowClick={handleRowClick}
            />
        </div>
    )
}

export default ProjectListContainer